module.exports = __webpack_public_path__ + "img/symbol_11.c6117007.png";